import { Language, Translator, genericEN, genericNL, setCurrentLanguage } from "@shared/locales";
import { en } from "./en";
import { nl } from "./nl";

const translator = new Translator();
translator.registerTranslations(Language.Nederlands, genericNL);
translator.registerTranslations(Language.Nederlands, nl);
translator.registerTranslations(Language.English, genericEN);
translator.registerTranslations(Language.English, en);

let currentLanguage = Language.Nederlands;
setCurrentLanguage(currentLanguage);
export const setLanguage = (language: string) => {
  currentLanguage = language === "en" ? Language.English : Language.Nederlands;
  setCurrentLanguage(currentLanguage);
};

export const getCurrentLanguage = () => {
  return currentLanguage;
};

export const translate = (key: string, properties: { [key: string]: string } = {}): string => {
  return translator.translate(key, properties);
};
